import { Box, Button, Typography } from "@mui/material"
import { getDocumentDeleteStatus, restoreDocument } from "api/services/quantum/document";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { ResType } from "types";
import Table from "components/Table";
import { useConfirm } from "context/ConfirmDialog";
import { snack } from "components/toast";
import { handleError } from "utils/handleError";

const DeletedDocument = () => {
    const confirm = useConfirm();
    const queryClient = useQueryClient();
    const { data, isLoading }: ResType = useQuery(
        ["deleted-documents"],
        getDocumentDeleteStatus, {
        onSuccess(res: any) {
            console.log("document deleted")
        }
    }
    );

    const { mutate } = useMutation(restoreDocument, {
        onSuccess: () => {
            snack.success("Document restored successfully");
            queryClient.invalidateQueries("deleted-documents");
        },
        onError: (err: any) => {
            if (err && !err?.error) {
                snack.error(handleError(err));
            } else if (!err?.error) {
                snack.error(`An error occurred while restoring Document`);
            }
        },
    });

    const handleRestore = (id: any) => {
        confirm({
            msg: "Are you sure you want to restore this Document?",
            action: () => mutate(id),
        });
    };
    return (
        <Box p={2}>
            <Typography variant="subtitle1" mb={2}>
                Deleted Documents
            </Typography>
            <Table
                loading={isLoading}
                data={data?.data || []}
                columns={[
                    {
                        key: "id",
                        title: "Document Id",
                    },
                    {
                        key: "templateName",
                        title: "Tempalte Name",
                    },
                    {
                        key: "Action",
                        title: "Action",
                        render: (item: any) => {
                            return (
                                <Button
                                    size="small"
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => handleRestore(item?.id)}
                                >
                                    Restore
                                </Button>
                            );
                        },
                    },
                ]}
            />
        </Box>
    )

}

export default DeletedDocument